import { numberWithCommas } from "@/utils";
import { Typography, Tooltip } from "@mui/material";

export const columns: IColumn<IVendor>[] = [
  {
    key: "manufacturerName",
    name: "Manufacturer Name",
    align: "left",
    sorting: false,
    width: "32%",  // Reduced from 35%
    minWidth: "140px",
    component: ({ manufacturerName }) => (
      <Typography
        variant="body2"
        sx={{
          fontSize: { xs: '9px', md: '10px', lg: '11px' },
          wordBreak: 'break-word',
          lineHeight: 1.3,
          display: 'block',
          overflowWrap: 'anywhere',
          // Allow wrapping to multiple lines and let the row grow vertically
          whiteSpace: 'normal',
        }}
      >
        {manufacturerName || 'N/A'}
      </Typography>
    ),
  },
  {
    key: "tariffValue",
    name: "Goods Value",
    align: "left",
    width: "16%",  // Slightly reduced from 17%
    minWidth: "75px",
    component: ({ tariffValue }) => {
      const label = `$${numberWithCommas(tariffValue)}`;
      return (
        <Tooltip title={label} arrow>
          <Typography variant="body2" sx={{ fontSize: { xs: '9px', md: '10px', lg: '11px' }, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {label}
          </Typography>
        </Tooltip>
      );
    },
  },
  {
    key: "tariffDuty",
    name: "Customs Duty",
    align: "left",
    width: "15%",  // Slightly reduced from 16%
    minWidth: "75px",
    component: ({ tariffDuty }) => {
      const label = `$${numberWithCommas(tariffDuty)}`;
      return (
        <Tooltip title={label} arrow>
          <Typography variant="body2" sx={{ fontSize: { xs: '9px', md: '10px', lg: '11px' }, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {label}
          </Typography>
        </Tooltip>
      );
    },
  },
  {
    key: "customValue",
    name: "Effective Duty Rate",
    align: "right",
    width: "17%",  // Same as before
    minWidth: "90px",
    component: ({ customValue }) => {
      const rate = customValue * 100;
      const color = rate < 5 ? "#2E7D32" : rate < 10 ? "#ED6C02" : "#D32F2F";
      const backgroundColor = rate < 5 ? "#E8F5E9" : rate < 10 ? "#FFF3E0" : "#FFEBEE";
      return (
        <Typography 
          variant="body2" 
          sx={{ 
            color,
            backgroundColor,
            fontWeight: 700,
            padding: { xs: "1px 3px", md: "2px 4px" },
            borderRadius: "4px",
            display: "inline-block",
            fontSize: { xs: "8px", md: "9px", lg: "10px" }
          }}
        >
          {rate.toFixed(2)}%
        </Typography>
      );
    },
  },
];
